import { routeToRegistrationProcessStart, redirectToPage } from '../pathInfo';
import { logoutRegistrant } from '../registrantLogin/actions';
import { getCurrentPageId } from '../reducer';
import { isRegistrationPage, isRegistrationDeclinePage } from '../selectors/pages';
import { openStartNewRegistrationDialog } from '../../../containers/StartNewRegistrationDialog';
import { currentRegistrant } from '../selectors';

/**
 * @param props.config.text Registration dialog text
 * @param props.style Styling for registration dialog
 * @param props.classes Classnames for registration dialog
 * Based on user state and current page
 * Dispatch actions either to redirect to registration start,
 * logout and redirect to 'register' page, or prompt with new registration dialog.
 * RegisterNow widget can exist in each of the conditions, all actions are available
 * RegisterAnother widget can only exists on post-reg pages,
 * openStartNewRegistrationDialog is the only available action
 */
export const promptToStartNewRegistration = (props) => {
  return async (dispatch, getState) => {
    const state = getState();
    const loggedIn = currentRegistrant.isLoggedIn(state);
    const currentPageId = getCurrentPageId(state);
    const registrationPage = isRegistrationPage(state, currentPageId);
    const registrationDeclinePage = isRegistrationDeclinePage(state, currentPageId);
    const titleText = props.config.text.htmlContent ?
      props.config.text.htmlContent.replace(/<[^>]*>/g, '') : props.config.text;
    if (!loggedIn && !registrationPage && !registrationDeclinePage) {
      return dispatch(routeToRegistrationProcessStart());
    }
    if (registrationDeclinePage) {
      await dispatch(logoutRegistrant());
      return dispatch(redirectToPage('register'));
    }
    return dispatch(openStartNewRegistrationDialog({
      title: titleText,
      classes: { ...props.classes },
      style: props.style
    }));
  };
};



// WEBPACK FOOTER //
// ./src/redux/modules/registrationForm/actions.js